import React, { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
//primereact
import { Button } from "primereact/button";
//components
import Modal from "../../components/modal/Modal";
import PasswordInput from "../../components/input/PasswordInput";
//services
import { patchAttPassword } from "../../services/Profile/patchAttPassword";

const ModalEditPassword = ({ visible, setVisible }) => {
  const form = useForm();
  const errors = form.formState.errors;
  const [loading, setLoading] = useState();

  const checkPasswordStrength = (password) => {
    const minLength = 8;
    const regexLowerCase = /[a-z]/;
    const regexUpperCase = /[A-Z]/;
    const regexDigit = /\d/;
    const regexSpecialChar = /[@$!%*?&#_+\-=/]/;
    if (password.length < minLength) {
      return "fraca";
    }
    let strength = 0;
    if (regexLowerCase.test(password)) strength++;
    if (regexUpperCase.test(password)) strength++;
    if (regexDigit.test(password)) strength++;
    if (regexSpecialChar.test(password)) strength++;
    if (strength < 3) {
      return "fraca";
    } else if (strength === 3) {
      return "média";
    } else {
      return "forte";
    }
  };

  const handleSubmit = async (data) => {
// console.log(data);
    setLoading(true);
    const notification = toast.loading("Por favor aguarde...");
    const senha = checkPasswordStrength(data.password);
    if (senha === "fraca" || senha === "média") {
      toast.update(notification, {
        render: `Senha ${senha}`,
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      form.setError("password");
      setLoading(false);
      return;
    }
    if (data.password !== data.password_confirmation) {
      toast.update(notification, {
        render: "Senhas diferentes, confirme sua senha novamente",
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      form.setError("password_confirmation");
      setLoading(false);
      return;
    }
    try {
      await patchAttPassword(data);
      toast.update(notification, {
        render: "Senha Alterada com Sucesso",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoading(false);
    } catch (error) {
      toast.update(notification, {
        render: error,
        autoClose: 5000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoading(false);
      return;
    }
    form.reset();
    setVisible(false);
  };

  return (
    <Modal
      visible={visible}
      position="center"
      onHide={() => setVisible(false)}
      dynamicTitle="Alterar Senha"
      dynamicWidth={window.innerWidth <= 992 ? "85vw" : "25vw"}
    >
      <form onSubmit={form.handleSubmit(handleSubmit)}>
        <h5>Para alterar sua senha, primeiro nos informe a sua antiga senha</h5>
        <PasswordInput
          label="Senha Anterior*"
          name="password_old"
          errors={errors}
          control={form.control}
          className="my-2"
          feedback={false}
          rules={{ required: "Senha obrigatória." }}
        />
        <hr />
        <PasswordInput
          label="Nova Senha*"
          name="password"
          errors={errors}
          control={form.control}
          className="my-2"
          feedback={true}
          rules={{ required: "Senha obrigatória." }}
        />
        <PasswordInput
          label="Confirme a Senha*"
          name="password_confirmation"
          errors={errors}
          control={form.control}
          className="my-2"
          feedback={false}
          rules={{ required: "Senha obrigatória." }}
        />
        <div className="d-flex justify-content-end mt-4">
          <Button
            label="Alterar Senha"
            icon="pi pi-check"
            type="submit"
            loading={loading}
            autoFocus
          />
        </div>
      </form>
    </Modal>
  );
};

export default ModalEditPassword;
